import React from 'react';
import { withSubmitQuoteVerify } from './hooks';
import { Done, Publish } from '@mui/icons-material';
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material';

function SubmitQuoteVerify(props) {
  const { handleDialogOpen, handleDialogClose, open, onSubmit, disabled, submitted } = props;

  return (
    <div>
      <div className="flex gap-4 items-center">
        {disabled && <div className="text-zinc-600">更改物料資料後，需儲存後才可核實</div>}
        <Button variant="outlined" endIcon={<Done />} onClick={handleDialogOpen} size="large" disabled={disabled}>
          核實報價
        </Button>
      </div>
      <div className={`flex justify-end items-center w-full`}>
        <Dialog
          open={open}
          onClose={handleDialogClose}
          sx={{
            '.MuiDialog-paper': {
              width: 500
            }
          }}
        >
          <DialogTitle>你確定核實報價嗎?</DialogTitle>
          <DialogContent>
            <DialogContentText>一旦確定後將無法修改</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDialogClose}>取消</Button>
            <Button onClick={onSubmit} variant="contained" autoFocus disabled={submitted}>
              確定
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

export default withSubmitQuoteVerify(SubmitQuoteVerify);
